// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActiveTextDisplaySettingsContent {
    padding: 2em;
    text-align: center;
    font-weight: bold;
    color: var(--settingsTextColor2);
}

.settingsDescription {
    font-size: 0.8em;
    color: var(--settingsTextColor);
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Settings/SettingsContent/SettingsContent.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC","sourcesContent":[".ActiveTextDisplaySettingsContent {\n    padding: 2em;\n    text-align: center;\n    font-weight: bold;\n    color: var(--settingsTextColor2);\n}\n\n.settingsDescription {\n    font-size: 0.8em;\n    color: var(--settingsTextColor);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
